import i18n from './index'
import { nextTick } from 'vue'

const Trans = {
  // Obtener el idioma actual
  get currentLocale() {
    return i18n.global.locale.value
  },

  // Establecer el idioma actual
  set currentLocale(newLocale) {
    i18n.global.locale.value = newLocale
  },

  // Obtener el idioma del navegador
  get userPreferredLanguage() {
    const userLang = navigator.language || navigator.userLanguage
    return userLang.split('-')[0]
  },

  // Guardar idioma en localStorage
  storeLanguagePreference(locale) {
    localStorage.setItem('user-locale', locale)
  },

  // Obtener el idioma guardado
  getStoredLanguage() {
    return localStorage.getItem('user-locale')
  },

  // Cargar mensajes de traducción para un idioma específico
  async loadLocaleMessages(locale) {
    // Si el idioma no está disponible, cargarlo
    if (!i18n.global.availableLocales.includes(locale)) {
      const messages = await import(`./locales/${locale}.json`)
      i18n.global.setLocaleMessage(locale, messages.default)
    }
    
    return nextTick()
  },

  // Cambiar de idioma
  async switchLanguage(newLocale) {
    // Cargar traducciones
    await Trans.loadLocaleMessages(newLocale)
    
    // Establecer como idioma actual
    Trans.currentLocale = newLocale
    
    // Establecer atributo lang del documento
    document.querySelector('html').setAttribute('lang', newLocale)
    
    // Guardar preferencia
    Trans.storeLanguagePreference(newLocale)
  },

  // Inicializar el idioma al cargar la aplicación
  async initializeI18n() {
    // Comprobar si hay un idioma guardado (preferencia manual del usuario)
    const storedLang = Trans.getStoredLanguage()
    
    if (storedLang) {
      // ✅ SIEMPRE respetar la elección manual del usuario
      if (['es', 'en'].includes(storedLang) && storedLang !== Trans.currentLocale) {
        await Trans.switchLanguage(storedLang)
      }
    } else {
      // ❌ NO hay preferencia guardada → Detectar automáticamente
      
      // Obtener idioma del navegador (ej: "es", "es-ES", "en-US", "fr-FR")
      const browserLang = navigator.language || navigator.userLanguage
      const primaryLang = browserLang.split('-')[0] // "es" de "es-ES"
      
      // Lógica: Si el navegador está en español → Español, si no → Inglés
      const detectedLang = primaryLang === 'es' ? 'es' : 'en'
      
      if (detectedLang !== Trans.currentLocale) {
        await Trans.switchLanguage(detectedLang)
      }
      
      // 🔔 IMPORTANTE: NO guardamos en localStorage aquí
      // Solo se guarda cuando el usuario cambia manualmente en el LanguageSwitcher
    }
  }
}

export default Trans 